
export interface Author {
  id: string;
  name: string;
  avatar: string;
  bio: string;
}

export interface Comment {
  id: string;
  content: string;
  author: Author;
  createdAt: string;
  replies: Comment[];
}

export interface Story {
  id: string;
  slug: string;
  title: string;
  subtitle: string;
  coverImage: string;
  excerpt: string;
  content: string;
  author: Author;
  publishedAt: string;
  category: string;
  readTime: number;
  tags: string[];
  featured: boolean;
  comments: Comment[];
  vimeo?: string | null; // Vimeo ID for story videos
}

export const MOCK_AUTHORS: Author[] = [
  {
    id: '1',
    name: 'John Doe',
    avatar: '/lovable-uploads/0478f0f4-6d1c-4e90-b08a-6bc2b74cd16c.png',
    bio: 'A passionate writer and storyteller.'
  },
  {
    id: '2',
    name: 'Jane Smith',
    avatar: '/placeholder-avatar.jpg',
    bio: 'An avid reader and insightful critic.'
  }
];

export const MOCK_COMMENTS: Comment[] = [
  {
    id: '101',
    content: 'Great article! Really enjoyed reading it.',
    author: MOCK_AUTHORS[0],
    createdAt: '2024-01-25T10:00:00Z',
    replies: []
  },
  {
    id: '102',
    content: 'I have a different perspective on this topic...',
    author: MOCK_AUTHORS[1],
    createdAt: '2024-01-25T11:30:00Z',
    replies: [
      {
        id: '103',
        content: 'Interesting point! Can you elaborate?',
        author: MOCK_AUTHORS[0],
        createdAt: '2024-01-25T12:00:00Z',
        replies: []
      }
    ]
  }
];

// Empty MOCK_STORIES as we're using Contentful stories
export const MOCK_STORIES: Story[] = [];
